import { IResource } from '../entities/resource';

export function isParking(res: IResource) {
  return ['parking_space', 'parking_lot'].includes(res.type);
}
